import { TooltipIconButton } from "@components/Atoms/TooltipIconButton";
import type { TotalOverview } from "@ext/git/core/GitDiffItemCreator/RevisionDiffPresenter";
import t from "@ext/localization/locale/translate";
import { confirmSkipHotKey } from "@ui-kit/ConfirmPopover";
import { TreeActions, TreeCheckbox, TreeMeta, TreeRow, TreeTitle, TreeTrailing } from "@ui-kit/Tree";
import { useState } from "react";
import { PUBLISH_TREE_TITLE_OFFSET } from "../constants";
import { DiscardConfirm } from "./DiscardConfirm";
import { PublishChangeCount } from "./PublishChangeCount";

export type PublishSelectAllRowProps = {
	isSelectedAll: boolean;
	overview: TotalOverview;
	canDiscard: boolean;
	discardCount: number;
	onSelectAll: (checked: boolean) => void;
	onDiscardAll: () => Promise<unknown>;
};

export const PublishSelectAllRow = ({
	isSelectedAll,
	overview,
	canDiscard,
	discardCount,
	onSelectAll,
	onDiscardAll,
}: PublishSelectAllRowProps) => {
	const [isConfirmingDiscard, setIsConfirmingDiscard] = useState(false);

	return (
		<TreeRow
			depth={0}
			isActive={false}
			isSelected={isSelectedAll}
			item={{ id: "select-all" }}
			onClick={() => onSelectAll(!isSelectedAll)}
			onSelect={onSelectAll}
			titleOffset={PUBLISH_TREE_TITLE_OFFSET}
		>
			<TreeCheckbox />
			<TreeTitle className="text-muted">{t("properties.select-all")}</TreeTitle>
			<TreeTrailing>
				<TreeMeta>
					<PublishChangeCount
						added={overview?.added}
						deleted={overview?.deleted}
						modified={overview?.modified}
						showTotal
					/>
				</TreeMeta>
				{canDiscard && (
					<TreeActions isPinned={isConfirmingDiscard}>
						<DiscardConfirm
							count={discardCount}
							onConfirm={onDiscardAll}
							onOpenChange={setIsConfirmingDiscard}
						>
							<TooltipIconButton
								className="shrink-0"
								hotKey={confirmSkipHotKey()}
								icon="reply-all"
								onClick={(event) => event.stopPropagation()}
								size="sm"
								tooltip={t("git.discard.select-all-arrow-tooltip")}
								variant="text"
							/>
						</DiscardConfirm>
					</TreeActions>
				)}
			</TreeTrailing>
		</TreeRow>
	);
};
